module.exports = __webpack_public_path__ + "static/img/wushipei.7819b17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/wushipei.svg
// module id = LYYC
// module chunks = 65